<div class="ct-input-component">
    <div [class.ct-list-opened]="isOpen" [canClickOverlay]="canClickOverlay" (clickOutside)="closeList()">
        <input class="ct-input ct-full-width"
               [type]="type"
               [disabled]="disabled"
               [placeholder]="placeholder"
               (focus)="openList()"
               (blur)="_onInputBlur()"
               [attr.maxlength]="maxlength"
               [(ngModel)]="modelValue"
               (ngModelChange)="updateModel(modelValue)">
        <mat-list class="ct-options-list" [style.maxHeight.px]="maxHeight">
            <div class="ct-options-wrapper" #slimScroll="slimScroll" slimScroll
                 [ctSlimScrollArrows]="slimScroll" [style.maxHeight.px]="maxHeight">
                <mat-list-item class="ct-option" role="option" *ngFor="let option of options; let i = index"
                              (click)="selectOption(option)" mat-ripple
                              [ngClass]="{ 'ct-option-selected': isOptionSelected(option), 'ct-option-disabled': option?.disabled }">
                    <label class="ct-label-item">{{getDisplayedName(option)}}</label>
                </mat-list-item>
            </div>
        </mat-list>
    </div>
</div>